import React, { Component } from 'react';

import imagen  from '../../../assets/img/header-banner-1.png';

class SubItem1 extends Component {
    state = {  }
    render() { 
        return (
            <div className="header" id = "item1">
                <div className="header-banner2" style={{backgroundImage: `url(${imagen})`, paddingLeft: "10%", paddingRight: "10%", paddingTop: 40, paddingBottom: 40}}>
                    <div style={{color:"a80012", fontSize: 30}} className="fuente-monserrat">A quiénes va dirigida</div>
                    <div align="justify" style={{color:"fff", fontSize: 16}} className="custom-mt-10 fuente-monserrat">
                        La carrera Diseño Gráfico está dirigida a bachilleres creativos, innovadores y proactivos que muestren interés por el Diseño, disposición para el trabajo en equipo, habilidad en el uso de la tecnología, facilidad para el dibujo y las técnicas de expresión, inclinación por la fotografía y la animación, capacidad de observación, análisis y síntesis, sensibilidad a las manifestaciones artísticas y culturales y disposición para la investigación.                    </div>
                    </div>
            </div>
        );
    }
}
 
export default SubItem1;


// WEBPACK FOOTER //
// ./src/site/Componentes/DiseñoGrafico/SubItem1.jsx